import dynamic from 'next/dynamic';

import { Container } from '@/atoms';
import { Benefits } from '@/templates';

import {
  blockSpacing,
  eyebrowClass,
  getRealUrl,
  sectionBgProps,
  textStyleClass,
} from '@/utils';

/**
 * ComponentRevisadasBeneficios
 */
export const ComponentRevisadasBeneficios = ({
  Eyebrow,
  Titulo,
  Descripcion,
  EyebrowEstilo,
  TituloEstilo,
  DescripcionEstilo,
  MargenAbajo,
  beneficios,
  Ancla,
  FondoSeccion,
  Espaciado,
}: any) =>
  beneficios?.length ? (
    <Container
      wrapper
      className={blockSpacing(Espaciado, MargenAbajo ? 'mb-12' : '')}
      id={Ancla}
      {...sectionBgProps(FondoSeccion)}
    >
      <Benefits
        eyebrow={Eyebrow}
        title={Titulo}
        description={Descripcion}
        eyebrowStyleClass={eyebrowClass(EyebrowEstilo)}
        titleStyleClass={textStyleClass(TituloEstilo)}
        descriptionStyleClass={textStyleClass(DescripcionEstilo)}
        benefits={beneficios.map((itm: any) => ({
          Icon: dynamic(
            () =>
              import(`@/icons/duotone/${itm.Icon.replaceAll('_', '-')}.svg`),
          ),
          description: itm.Descripcion,
          title: itm.Titulo,
          image: {
            src: getRealUrl(itm.image?.url),
            alt: itm.image?.alternativeText || itm.Titulo,
          },
        }))}
      />
    </Container>
  ) : null;

ComponentRevisadasBeneficios.displayName = 'ComponentRevisadasBeneficios';
